import Select from '@app/src/components/Form/Select/ControlledSelect'
import TextField from '@app/src/components/Ui/TextField'
import useCurrentProviderTypeName from '@app/src/hooks/currentProviderTypeName'
import { getYears } from '@app/src/utils'
import { Grid, Typography } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { PROGRESS_TRACKER_QUESTION_KEYS } from './CreateProgressTrackerModal'

const SupplierScopeField = () => {
  const { control, errors, register } = useFormContext()
  const { formatMessage } = useIntl()
  const providerType = useCurrentProviderTypeName({ isPlural: true })

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={5.5}>
        <TextField
          sx={{ width: 1 }}
          fullWidth
          type="number"
          label={formatMessage(
            { id: 'schemas.progressTracker.createNewModal.numberOfProvidersInScope' },
            { providerType },
          )}
          placeholder={formatMessage({
            id: 'schemas.progressTracker.createNewModal.numberOfProvidersInScopePlaceholder',
          })}
          name={PROGRESS_TRACKER_QUESTION_KEYS.TOTAL_COMPANIES_IN_SCOPE}
          error={errors?.totalCompaniesInScope?.message}
          inputRef={register({
            valueAsNumber: true,
          })}
        />
      </Grid>
      <Grid item xs={1}>
        <Typography pt={2} align="center">
          by
        </Typography>
      </Grid>
      <Grid item xs={5.5}>
        <Select<string>
          fullWidth
          hoveringLabel
          name={PROGRESS_TRACKER_QUESTION_KEYS.SCOPE_TARGET_PERIOD_NAME}
          options={getYears(0, 20, 'ASC').map(y => ({ value: y.toString(), label: y.toString() }))}
          error={errors?.scopeTargetPeriodName?.message}
          fieldLabel={formatMessage({ id: 'reporting.period' })}
          control={control}
        />
      </Grid>
    </Grid>
  )
}

export default SupplierScopeField
